module.exports = __webpack_public_path__ + "static/media/vegitables_78.4072219c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_78.csv
// module id = 666
// module chunks = 0